import React from 'react';

import Link from '@/components/Link';

interface PersonalReviewBannerProps {
  /** Viewer's true requester-pending count from `unreviewedConsultations`. */
  count: number;
}

// Personal nudge: "{n} consultations awaiting your review". Backed by the
// viewer-scoped `unreviewedConsultations` count (Redux state.consultations.
// unreviewed), it lives in the My-activity Consultations container — not the
// account-level Account Overview. Reworded to drop the old Account-scoped
// "unlock value insights below" coupling.
export function PersonalReviewBanner({ count }: PersonalReviewBannerProps): React.ReactNode {
  if (count <= 0) return null;

  return (
    <div className="mb-12 flex items-center gap-12 rounded-md bg-yellow-500/15 px-14 py-10">
      <svg
        className="h-[1.6rem] w-[1.6rem] shrink-0 text-yellow-700 dark:text-yellow-300"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      <div className="flex-1 text-12">
        <span className="font-semibold text-yellow-800 dark:text-yellow-300">
          {`${count} consultation${count !== 1 ? 's' : ''} awaiting your review.`}
        </span>{' '}
        <span className="text-on-surface-secondary">
          Share quick feedback to help us match better experts for you.
        </span>
      </div>
      <Link
        to="/consultations?filter=needs_review"
        className="inline-flex shrink-0 items-center rounded-md bg-brand-primary px-12 py-6 text-12 font-semibold text-surface-card no-underline shadow-5 transition-shadow hover:bg-brand-primary-hover hover:shadow-1"
      >
        Review {count}
      </Link>
    </div>
  );
}
